import { useEffect, useState } from "react";
import { routes } from "@/router";
import { useNavigate } from "react-router-dom";

import { useGetOrgaInfo } from "@/hooks/api/organisation/useGetOrgaInfo";
import { OrganizationUpdate } from "@/hooks/api/organisation/useUpdateOrganisation";
import { UserUpdate } from "@/hooks/api/user/useUpdateUser";
import OnboardingCompany from "@/components/organisms/onboarding/OnboardingCompany";
import OnboardingUser from "@/components/organisms/onboarding/OnboardingUser";

enum OnboardingStep {
  ORGANIZATION_DATA = "ORGANIZATION_DATA",
  USER_DATA = "USER_DATA",
  FINISHED = "FINISHED",
}

const OnboardingWizard = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [maxSteps, setMaxSteps] = useState(1);
  const [isBack, setIsBack] = useState(false);
  const [stepEnum, setStepEnum] = useState<OnboardingStep>(OnboardingStep.ORGANIZATION_DATA);
  const { data: orgaData } = useGetOrgaInfo();

  const [companyData, setCompanyData] = useState<OrganizationUpdate>({
    companyName: "",
    companyUrl: "",
  });

  useEffect(() => {
    setCompanyData({
      companyName: orgaData?.name || "",
      companyUrl: orgaData?.website || "",
    });
  }, [orgaData]);

  useEffect(() => {
    if (isBack) return;
    if (orgaData?.onboarding_step === "ORGANIZATION_DATA") {
      setMaxSteps(2);
      setStepEnum(OnboardingStep.ORGANIZATION_DATA);
    } else {
      setMaxSteps(1);
      setStepEnum(OnboardingStep.USER_DATA);
    }
  }, [orgaData, isBack]);

  const setBackStep = () => {
    setIsBack(true);
    setStep((prev) => prev - 1);
    setStepEnum(OnboardingStep.ORGANIZATION_DATA);
  };

  const handleNext = (formData: OrganizationUpdate | UserUpdate) => {
    switch (stepEnum) {
      case OnboardingStep.ORGANIZATION_DATA:
        setCompanyData(formData as OrganizationUpdate);
        setStep((prev) => prev + 1);
        setStepEnum(OnboardingStep.USER_DATA);
        break;
      case OnboardingStep.USER_DATA:
        navigate(routes.search);
        break;
    }
  };

  return (
    <div
      className={
        "relative flex h-full max-h-[800px] w-full max-w-xl flex-col gap-y-8 rounded-xl border border-secondary p-10 shadow-md"
      }
    >
      {stepEnum === OnboardingStep.ORGANIZATION_DATA && (
        <OnboardingCompany handleNext={handleNext} step={step} maxSteps={maxSteps} defaultValues={companyData} />
      )}

      {stepEnum === OnboardingStep.USER_DATA && (
        <OnboardingUser handleBack={setBackStep} handleNext={handleNext} step={step} maxSteps={maxSteps} />
      )}
    </div>
  );
};

export default OnboardingWizard;
